import {  Divider } from "@mui/material";
import { FC } from "react";
import {
  List,
  ListItem,
  ListItemSecondaryAction,
} from "@mui/material";
import { H4 } from "../components/Typography";

interface ReturnInformationProps {
  item: {
    label: string;
    value: string | number;
    mf_trailing?: Array<{
      name: string;
      value: number;
    }>;
  };
}
const ReturnInformation: FC<ReturnInformationProps> = ({ item }) => {

  const trailingReturns = item?.mf_trailing?.map((obj: any) => {
    const key = Object.keys(obj)[0];
    const value = obj[key];
    return { key, val: value };
  });

  const getfulltext = (val: any) => {
    if (val == "1M") {
      return "1 Month";
    } else if (val == "3M") {
      return "3 Months";
    } else if (val == "6M") {
      return "6 Months";
    } else if (val == "1Y") {
      return "1 Year";
    } else if (val == "3Y") {
      return "3 Years";
    } else if (val == "5Y") {
      return "5 Years";
    } else if (val == "7Y") {
      return "7 Years";
    } else {
      return val;
    }
  };
  return (
    <>
      <ListItem
        sx={{
          display: "flex",
          justifyContent: "space-between",
          py: 0.5,
          px: 2,
          mt: 1,
        }}
      >
        <H4>Period</H4>
        <H4>Returns</H4>
      </ListItem>
      <List>
        {trailingReturns?.map((data, index) => (
          <>
            <ListItem
              key={data.key}
              disableGutters
              sx={{
                display: "flex",
                justifyContent: "space-between",
                py: 0.5,
                px: 2,
                pl:2,
                pt:1,pb:1,
                background: "#fff",
              }}
            >
              <H4 sx={{ minWidth: "50%" }}>{getfulltext(data.key)}</H4>
              <ListItemSecondaryAction>
                <H4 sx={{ minWidth: "50%", mr: 2 }}>{data.val}%</H4>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
          </>
        ))}
      </List>
    </>
  );
};

export default ReturnInformation;
